import {mockResponse} from '../responseHelper'

const prcWsGenresResponse = {
    "genres": [
        "Adventure fiction",
        "Animal fiction",
        "Australian fiction",
        "Biographies",
        "Classics",
        "Drama",
        "Factual",
        "Family/Relationships",
        "Fantasy",
        "Historical fiction",
        "Humorous fiction",
        "Love stories",
        "Mystery/Suspense",
        "Picture books",
        "Poetry",
        "School fiction",
        "Science fiction",
        "Short stories",
        "Sports fiction",
        "mock-up testting genres",
    ]
};

const prcWsRulesResponse = {
    "rules": [
        {
            "transactionId": 0,
            "challengeId": 56,
            "challengeYear": 2018,
            "challengeName": "k-2",
            "totalBooks": 30,
            "maxChoiceBooks": 5,
            "readingLevels": [
                {
                    "transactionId": 3,
                    "levelId": 3,
                    "levelName": "5-6",
                    "groupedByGenre": true,
                    "archive": false
                },
                {
                    "transactionId": 6,
                    "levelId": 4,
                    "levelName": "7-9",
                    "groupedByGenre": true,
                    "includeLevelId": 3,
                    "archive": false
                },
                {
                    "transactionId": 0,
                    "levelId": 1,
                    "levelName": "K-2",
                    "groupedByGenre": false,
                    "archive": false
                },
                {
                    "transactionId": 0,
                    "levelId": 2,
                    "levelName": "3-4",
                    "groupedByGenre": true,
                    "archive": false
                }
            ],
            "publicFacing": true,
            "minPrcBooks": 25
        },
        {
            "transactionId": 0,
            "challengeId": 57,
            "challengeYear": 2018,
            "challengeName": "7-9",
            "totalBooks": 30,
            "maxChoiceBooks": 5,
            "readingLevels": [],
            "publicFacing": true,
            "minPrcBooks": 25
        },
        {
            "transactionId": 0,
            "challengeId": 57,
            "challengeYear": 2018,
            "challengeName": "3-4",
            "totalBooks": 30,
            "maxChoiceBooks": 5,
            "readingLevels": [],
            "publicFacing": true,
            "minPrcBooks": 25
        },
        {
            "transactionId": 0,
            "challengeId": 57,
            "challengeYear": 2018,
            "challengeName": "5-6",
            "totalBooks": 30,
            "maxChoiceBooks": 5,
            "readingLevels": [],
            "publicFacing": true,
            "minPrcBooks": 25
        },
        {
            "transactionId": 0,
            "challengeId": 57,
            "challengeYear": 2018,
            "challengeName": "3-9",
            "totalBooks": 30,
            "maxChoiceBooks": 5,
            "readingLevels": [],
            "publicFacing": false,
            "minPrcBooks": 25
        }
    ]
};

const prcWsLogonEnabledResponse = {
    "logonEnabled": [
        "false",
        "false",
        "Students are unable to log on until the PRC reopens again in 2025"
    ]
};
const prcSurveyResponse = {
    message: 'Successfully mailed PRC team',
    ok: true,
    surveyTaken: '0'
}

export default function (url, options) {
    let body;
    switch(url) {
        case '/prcws/genres':
            body = prcWsGenresResponse;
            break;
        case '/prcws/challenge_rules':
            body = prcWsRulesResponse;
            break;
        case '/prcws/challenge_survey':
            body = prcSurveyResponse;
            break;
        case '/prcws/logon_enabled':
            body = prcWsLogonEnabledResponse;
        default:
            break;
    }

    return Promise.resolve(mockResponse('application/json', body))
}

